var _defs, _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElementEarth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "earthBg",
    x1: 8,
    y1: 8,
    x2: 88,
    y2: 88,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F4D9A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC9C58"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 22,
    fill: "url(#earthBg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 56L35 33L56 39L73 60L58 74L34 71L20 56Z",
    fill: "#7E5A2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 39L45 30L62 36L52 45L31 39Z",
    fill: "#967044"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 55L49 49L61 58L51 66L35 55Z",
    fill: "#B78652"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementEarth);
export default __webpack_public_path__ + "static/media/element-earth.119d547941d819e3202a9c40d9c18d7e.svg";
export { ForwardRef as ReactComponent };